import { Bot } from 'lucide-react'

/**
 * Welcome screen shown when no messages exist yet.
 * Claude/ChatGPT-style centered greeting.
 */
export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center py-20">
      <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-5">
        <Bot className="h-7 w-7 text-primary" />
      </div>
      <h2 className="text-xl font-semibold text-foreground mb-2">
        How can I help you?
      </h2>
      <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
        Ask a question to get started. I can analyze data across multiple sources,
        generate reports, and answer complex queries.
      </p>
    </div>
  )
}
